import _ from 'lodash'

export default class FilesBreadcrumbsModel {
  items = []
  remoteFolder = null
  root = null

  constructor(data = {}) {
    _.forEach(data, (value, field) => {
      this[_.camelCase(field)] = value
    })
  }

  /**
   *
   * @param {string} routeName
   * @returns {array}
   */
  generateBreadcrumbs(routeName = '') {
    if (_.isArray(this.items)) {
      return this.items
        .filter(item => item && item.name)
        .map(item => {
          if (item.id) {
            let suffix = '.folder'
            let toParams = {
              folderId: item.id,
            }
            let query
            if (routeName.includes('driveDocuments')) {
              suffix = ''
              toParams = null
              query = {
                path: item.id,
              }
            }
            return {
              text: item.name,
              to: {
                name: `${routeName?.replace('.folder', '')}${suffix}`,
                params: { ...toParams },
                query: { ...query },
              },
            }
          }
          return {
            text: item.name,
            to: {
              // Hacky, may use something else
              name: routeName?.replace('.folder', ''),
            },
          }
        })
    }
    return []
  }

  /**
   * @returns {?string}
   */
  getRemotePath() {
    return this.root
  }
}
